import { Typography, Box } from "@mui/material";
import { ErrorMessage, Field } from "formik";
import React, { useEffect, useState } from "react";
import TextError from "../TextError";
import "./FirmikField.css";

const FirmikFileField = (props) => {
  const {
    label,
    name,
    validation,
    options,
    dependent,
    hidden,
    arrayindex,
    manualValidation,
    errors,
    arrayvalues,
    len,
    ...rest
  } = props;

  useEffect(() => {}, []);

  return (
    <div className=" form-control ">
      <div className="">
        <div>
          <label>{label}</label>
        </div>
        <div>
          <Field name={name} {...rest}>
            {({ field, form, setErrors }) => {
              const { setFieldValue, setFieldError, values } = form;

              const fileToBase64 = (file, cb) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = function () {
                  //console.log('reader',reader.result)
                  // console.log('reader',reader.result.split(';'))
                  const base64String = reader.result
                    .replace("data:", "")
                    .replace(/^.+,/, "");

                  //                  console.log('readerString',base64String)

                  //cb(null, reader.result)
                  cb(null, base64String);
                };

                reader.onerror = function (error) {
                  cb(error, null);
                };
              };

              const onUploadFileChange = ({ target }, size) => {
                console.log(target.files[0], "fileConsole");

                if (target.files < 1 || !target.validity.valid) {
                  return;
                }

                const file = target.files[0];
                const defaultSize = size ? 1.5 : 3;

                if (file?.size / 1024 / 1024 <= defaultSize) {
                  const fileType = file.type.split("/")[1];
                  const defaultType = ["pdf", "jpeg", "jpg", "tiff","docx"];

                  if (defaultType.includes(fileType)) {
                    fileToBase64(target.files[0], (err, result) => {
                      if (result) {
                        let neRes = {
                          name: target.files[0].name,
                          value: result,
                        };
                        //setFieldValue(name,result)
                        setFieldValue(name, neRes);
                      }
                    });
                  } else {
                    target.value = "";
                    alert(
                      "Unknown file type, File type must be one of [ pdf , jpeg , jpg , tiff, docx]"
                    );
                  }
                } else {
                  alert(`File size must be of ${defaultSize}mb or less`);
                  target.value = "";
                }
              };

              return (
                <div className="FileUpload">
                  {
                    <Field
                      type="file"
                      className=" "
                      name={name}
                      id={name}
                      {...field}
                      onChange={onUploadFileChange}
                      value={values[`${name}`]}
                      style={{ color: "transparent" }}
                      // value={"file"}
                    />
                  }

                  {name.includes("primaryDetails.Documents[0]") ? (
                    name ===
                    "primaryDetails.Documents[0].AddressProof.ProofImage" ? (
                      <label>
                        {values.primaryDetails.Documents[0].AddressProof
                          .ProofImage?.name === undefined
                          ? "no file choosen"
                          : values.primaryDetails.Documents[0].AddressProof
                              .ProofImage.name}
                      </label>
                    ) : name ===
                      "primaryDetails.Documents[0].IDProof.ProofImage" ? (
                      <label>
                        {values.primaryDetails.Documents[0].IDProof.ProofImage
                          ?.name === undefined
                          ? "no file choosen"
                          : values.primaryDetails.Documents[0].IDProof
                              .ProofImage.name}
                      </label>
                    ) : name ===
                      "primaryDetails.Documents[0].AgeProof.ProofImage" ? (
                      <label>
                        {values.primaryDetails.Documents[0].AgeProof.ProofImage
                          ?.name === undefined
                          ? "no file choosen"
                          : values.primaryDetails.Documents[0].AgeProof
                              .ProofImage.name}
                      </label>
                    ) : name ===
                      "primaryDetails.Documents[0].LAPhoto.ProofImage" ? (
                      <label>
                        {values.primaryDetails.Documents[0].LAPhoto.ProofImage
                          ?.name === undefined
                          ? "no file choosen"
                          : values.primaryDetails.Documents[0].LAPhoto
                              .ProofImage.name}
                      </label>
                    ) : name ===
                      "primaryDetails.Documents[0].IncomeProof.ProofImage" ? (
                      <label>
                        {values.primaryDetails.Documents[0].IncomeProof
                          .ProofImage?.name === undefined
                          ? "no file choosen"
                          : values.primaryDetails.Documents[0].IncomeProof
                              .ProofImage.name}
                      </label>
                    )
                    : name ===
                      "primaryDetails.Documents[0].ProposerIDProof.ProofImage" ? (
                      <label>
                        {values.primaryDetails.Documents[0].ProposerIDProof.ProofImage
                          ?.name === undefined
                          ? "no file choosen"
                          : values.primaryDetails.Documents[0].ProposerIDProof
                              .ProofImage.name}
                      </label>
                    ) 
                    : name ===
                      "primaryDetails.Documents[0].ProposerPhoto.ProofImage" ? (
                      <label>
                        {values.primaryDetails.Documents[0].ProposerPhoto.ProofImage
                          ?.name === undefined
                          ? "no file choosen"
                          : values.primaryDetails.Documents[0].ProposerPhoto
                              .ProofImage.name}
                      </label>
                    ) 
                    : name ===
                      "primaryDetails.Documents[0].LA Photo.ProofImage" ? (
                      <label>
                        {values.primaryDetails.Documents[0]['LA Photo'].ProofImage
                          ?.name === undefined
                          ? "no file choosen"
                          : values.primaryDetails.Documents[0]['LA Photo']
                              .ProofImage.name}
                      </label>
                    ) 
                    : name ===
                      "primaryDetails.Documents[0].ProposerProof.ProofImage" ? (
                      <label>
                        {values.primaryDetails.Documents[0].ProposerProof.ProofImage
                          ?.name === undefined
                          ? "no file choosen"
                          : values.primaryDetails.Documents[0].ProposerProof
                              .ProofImage.name}
                      </label>
                    ) 
                    : null
                  ) : null}

                  {/* <label htmlFor={field.name}>{field.label}</label> */}
                </div>
              );
            }}
          </Field>
        </div>
      </div>

      <ErrorMessage name={name} component={TextError} />
    </div>
  );
};

export default FirmikFileField;
